import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {
  getSMEs: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = { filters: data.filters };

      api
        .get("admin/smes", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getSME: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/smes/" + data.id, {})
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createSME: function({ commit }, data) {
    data.dob = "1970/05/05";
    return new Promise((resolve, reject) => {
      api
        .post("admin/smes", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  editSME: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/smes/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getSMECourses: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/smes/" + data.id + "/courses", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  SMELanguageSearch: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/languages/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  SMELanguageAvailabilty: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .put("admin/languages/" + data.id + "/" + data.status, {})
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/SMEModule.js